export default __webpack_public_path__ + "static/Rectangle4387-6485aa5059d79d08aed0eb33c467b9f0.png";